import React from 'react';
import {ApplicationWorkflowSwitch} from "./ApplicationWorkflowSwitch";
import {ApplicationDataSource} from 'portal-core/components/data/ApplicationDataSource';
import {NavigationConsumer} from "portal-core/navigation/NavigationConusmer";
import {setAllowedAttributes} from 'portal-core/api/index';

export function ApplicationPage({developerInfo, quoteRetrievalFields}) {

  setAllowedAttributes(quoteRetrievalFields);
  return <NavigationConsumer>
    {
      ([applicationId]) => <ApplicationDataSource applicationId={applicationId}>
        <ApplicationWorkflowSwitch/>
      </ApplicationDataSource>
    }
  </NavigationConsumer>;
}
